/**
 * Created by kellermaca on 8/08/17.
 */
export default {
  is_authenticated: state => {
    return state.is_authenticated
  },
  error_authenticated: state => {
    return state.error_authenticate || false
  },
  error: state => {
    return state.error_authenticate || false
  },
  list_facturas_headers: state => {
    return state.list_headers
  },
  cliente: state => {
    console.log(state.cliente)
    return state.cliente
  },
  getguardando: state => {
    return state.guardando
  },
  getmessageactual: state => {
    return state.messageactual
  },
  getidfactura: state => {
    return state.idsfacturas
  },
  listadodevoluciones: state => {
    return state.devoluciones
  },
  get_vender_bodega: state => {
    return state.vender_bodega
  },
  get_error_searchcliente: state => {
    return state.error_cliente
  },
  factura: state => {
    return state.factura
  },
  hasfactura: state => {
    return state.has_factura
  },
  hascotizacion: state => {
    return state.has_cotizacion
  },
  producto: state => {
    return state.producto
  },
  listado: state => {
    return state.listado
  },
  getlineanota: state => {
    return state.lineanota
  },
  lineasfactura: state => {
    return state.lineas
  },
  lineascotizacion: state => {
    return state.lineascotizacion
  },
  cantidad: state => {
    return state.fcantidad
  },
  presentaciones: state => {
    return state.presentaciones
  },
  presentacion: state => {
    return state.presentacion
  },
  default: state => {
    return state.producto.listaprecios.find(data => { return data.lista.nombre.toLowerCase() === 'detalle' })
  },
  dialogo: state => {
    return state.dialog
  },
  vehiculo: state => {
    return state.vehiculo
  },
  message_error: state => {
    return state.messageerror
  },
  message_success: state => {
    return state.messagesuccess
  },
  error_numero: state => {
    return state.error
  },
  success: state => {
    return state.success
  },
  listadofacturas: state => {
    return state.facturas
  },
  listadocotizaciones: state => {
    return state.cotizaciones
  },
  clientes: state => {
    return state.clientes
  },
  clientescotizacion: state => {
    return state.clientecotizacion
  },
  rutas: state => {
    return state.rutas
  },
  bancos: state => {
    return state.bancos
  },
  usuarios: state => {
    return state.usuarios
  },
  productos: state => {
    return state.productos
  },
  getdia: state => {
    return state.dia
  },
  getruta: state => {
    return state.ruta
  },
  getusuario: state => {
    return state.usuario
  },
  getBanco: state => {
    return state.banco
  },
  getBanco2: state => {
    return state.banco2
  },
  getBanco3: state => {
    return state.banco3
  },
  getsemana: state => {
    return state.semana
  },
  getdesde: state => {
    return state.desde
  },
  gethasta: state => {
    return state.hasta
  },
  gettipo: state => {
    return state.tipo
  },
  kilometraje: state => {
    return state.kilometrajes
  },
  akilometraje: state => {
    return state.akilometraje
  },
  kilometrajevendedor: state => {
    return state.kilometrajesvendedor
  },
  akilometrajevendedor: state => {
    return state.akilometrajevendedor
  },
  vehiculos: state => {
    return state.vehiculos
  },
  getextracciones: state => {
    return state.extracciones
  },
  gettipoextracciones: state => {
    return state.tiposextracciones
  },
  getactivadorcliente: state => {
    return state.activadorcliente
  },
  getCaja: state => {
    return state.caja
  },
  getcompras: state => {
    return state.compras
  },
  getCompra: state => {
    return state.compra
  },
  getProveedores: state => {
    return state.proveedores
  },
  getEditCompra: state => {
    return state.editcompra
  },
  getLineaCompra: state => {
    return state.lineacompra
  },
  getListadoPresentaciones: state => {
    return state.listadopresentacion
  },
  getEliminando: state => {
    return state.eliminando
  }
}




// WEBPACK FOOTER //
// ./src/store/getters/getters.js